import { render, staticRenderFns } from "./modalEditarGrupo.vue?vue&type=template&id=14d99caa"
import script from "./modalEditarGrupo.vue?vue&type=script&lang=js"
export * from "./modalEditarGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports